import styles from "../../css/coursedetails.module.css";

function HtmlOutline() {
  return (
    <>
      <p>
        <strong>This Course is also available in the following program:</strong>
      </p>
      <ul className={styles.learnStruct}>
        <li>Frontend Development</li>
        <li>Web Development Basics</li>
      </ul>
    </>
  );
}

export default HtmlOutline;
